module.exports = __webpack_public_path__ + "static/media/shema-dark.de1b723f.png";